import {
    doc,
    getFirestore,
    onSnapshot,
    serverTimestamp,
    setDoc,
} from './instrumentedFirestore';
import { getFirebaseApp } from './app';
import { tenantClassTimetableDocPath } from '@constants/firestorePaths';

function db() {
    return getFirestore(getFirebaseApp());
}

/**
 * Subscribes to the weekly timetable document for a given class.
 */
export function subscribeClassTimetable({ tenantId, classId, onNext, onError }) {
    if (!tenantId) throw new Error('Missing tenantId');
    if (!classId) throw new Error('Missing classId');
    const path = tenantClassTimetableDocPath(tenantId, classId);
    const ref = doc(db(), path);
    return onSnapshot(
        ref,
        (snap) => {
            const data = snap.data() || {};
            onNext?.(data);
        },
        onError
    );
}

/**
 * Saves/updates the weekly timetable document for a given class.
 */
export async function persistClassTimetable({ tenantId, classId, days }) {
    if (!tenantId) throw new Error('Missing tenantId');
    if (!classId) throw new Error('Missing classId');
    const path = tenantClassTimetableDocPath(tenantId, classId);
    const ref = doc(db(), path);
    await setDoc(
        ref,
        {
            tenantId,
            classId,
            days: days || {},
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
}
